import type { SeatMapConfig } from "@/types/records";
import type { CertificateConfig } from "@/pages/producer/certificates/types";

function object(value: unknown): Record<string, unknown> {
  return value !== null && typeof value === "object" && !Array.isArray(value)
    ? value as Record<string, unknown> : {};
}

export function readSeatMapConfig(value: unknown): SeatMapConfig {
  const config = object(value);
  const tierColors = Object.fromEntries(Object.entries(object(config.tierColors))
    .filter((entry): entry is [string, string] => typeof entry[1] === "string"));
  return { ...config, imageUrl: typeof config.imageUrl === "string" ? config.imageUrl : undefined, tierColors };
}

export function readCertificateConfig(value: unknown): Partial<CertificateConfig> {
  // Legacy persisted layouts are validated by the certificate pipeline before rendering.
  const config = object(value);
  return {
    ...config,
    eligible_tier_ids: Array.isArray(config.eligible_tier_ids)
      ? config.eligible_tier_ids.filter((id): id is string => typeof id === "string") : undefined,
    require_feedback: config.require_feedback === true,
  } as Partial<CertificateConfig>;
}

export function readRecipientFilter(value: unknown): { status?: string; tier_ids?: string[] } {
  const filter = object(value);
  return {
    status: typeof filter.status === "string" ? filter.status : undefined,
    tier_ids: Array.isArray(filter.tier_ids) ? filter.tier_ids.filter((id): id is string => typeof id === "string") : undefined,
  };
}
